const LEGACY_FALLBACK_SINGLE_TENANT_ID = 859606760;

export function resolveEffectiveTenantNumber(): number {
  const raw =
    process.env.NEXT_PUBLIC_TENANT_ID ??
    process.env.API_X_TENANT_ID ??
    process.env.X_TENANT_ID ??
    process.env["X-Tenant-Id"];
  if (raw !== undefined && String(raw).trim() !== "") {
    const n = Number(String(raw).trim());
    if (!Number.isNaN(n)) return n;
  }
  return LEGACY_FALLBACK_SINGLE_TENANT_ID;
}

export function getEffectiveTenantApiHeaders(): Record<string, string> {
  return { "X-Tenant-ID": String(resolveEffectiveTenantNumber()) };
}
